import { render, staticRenderFns } from "./serveRecords.vue?vue&type=template&id=4940f9fa&scoped=true"
import script from "./serveRecords.vue?vue&type=script&lang=js"
export * from "./serveRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4940f9fa",
  null
  
)

export default component.exports